import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import DbConn from '~/Classes/siteVars.js'
import i18n from '~/i18n'
import { Translation } from 'react-i18next'
import queryString from 'query-string'
import LeftPanel from './loginAttractMode.jsx'
import LandingPageTemplate from './template.jsx'
import { isPasswordStrongEnough } from '~/utils/passwordPolicy'

@connect((store) => {
    return {
        siteMaster: store.siteMaster
    }
})
export default class ResetTemplate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            password: '',
            repeatPassword: '',
            email: '',
            guid: '',
            success: false,
            strength: 0,
            strongEnough: true,
            type: 'password',
            loaded: false,
            loading: false
        }
        this.handleChange = this.handleChange.bind(this)
        this.send = this.send.bind(this)
        this.checkStrength = this.checkStrength.bind(this)
    }

    componentDidMount() {
        const query = queryString.parse(this.props.location.search)
        var email = query.email
        var guid = query.guid

        this.setState({
            email,
            guid,
            loaded: true
        })
    }

    handleChange(event) {
        this.setState(
            {
                [event.currentTarget.name]: event.currentTarget.value
            },
            this.checkStrength
        )
    }

    checkStrength() {
        var password = this.state.password
        var strength = 0

        if (password.length >= 10) strength += 1
        if (/\d/.test(password)) strength += 1
        if (/[A-Z]/.test(password)) strength += 1
        if (/[a-z]/.test(password)) strength += 1

        var error = ''
        var strongEnough = !password || isPasswordStrongEnough(password)

        if (strongEnough && this.state.repeatPassword && password !== this.state.repeatPassword) {
            error = i18n.t('login:reset.noMatch')
        }

        this.setState({
            strength,
            strongEnough,
            masterErrorMsg: error
        })
    }

    send() {
        if (!this.state.password) {
            return this.setState({
                masterErrorMsg: i18n.t('login:reset.required')
            })
        }
        if (!this.state.repeatPassword || this.state.password !== this.state.repeatPassword) {
            return this.setState({
                masterErrorMsg: i18n.t('login:reset.noMatch')
            })
        }

        if (!isPasswordStrongEnough(this.state.password)) {
            return this.setState({
                masterErrorMsg: i18n.t('login:reset.strong'),
                strongEnough: false
            })
        }

        if (!this.state.guid) {
            return this.setState({
                masterErrorMsg: i18n.t('login:reset.noMatch')
            })
        }

        var self = this
        var baseUrl = DbConn.getConnString()
        this.setState({ loading: true, masterErrorMsg: '' })
        axios
            .post(baseUrl + '/resetpassword', {
                emailAddress: this.state.email,
                token: this.state.guid,
                password: this.state.password
            })
            .then(function (response) {
                var respData = response.data
                if (respData.success === false) {
                    self.setState({ masterErrorMsg: response.data.message, loading: false })
                }
                if (respData.success === true) {
                    self.setState({ success: true, loading: false })
                }
            })
            .catch((error) => {
                let message = 'Something went wrong'
                if (error && error.response && error.response.data && error.response.data.error) {
                    message = error.response.data.error
                }
                if (error && error.response && error.response.data && error.response.data.message) {
                    message = error.response.data.message
                }
                self.setState({ masterErrorMsg: message, loading: false })
            })
    }

    render() {
        return (
            <Translation ns='translations'>
                {(t, { i18n }) => {
                    let header = t('login:reset.header')
                    let subheader = t('login:reset.subheader', { siteName: this.props.siteMaster.siteName })
                    if (this.state.success) {
                        header = t('login:reset.success')
                        subheader = t('login:reset.successSub', { siteName: this.props.siteMaster.siteName })
                    }

                    if (this.state.loaded && (!this.state.guid || !this.state.email)) {
                        return (
                            <LandingPageTemplate paperClasses='landing-login' header={t('login:reset.invalidLink')}>
                                <Button
                                    className='button-primary button-fullwidth'
                                    iconRight={<Icons icon='arrowRight' />}
                                    to='/'
                                >
                                    {t('login:reset.back', { siteName: this.props.siteMaster.siteName })}
                                </Button>
                            </LandingPageTemplate>
                        )
                    }

                    return (
                        <LandingPageTemplate paperClasses='landing-login' header={header} subheader={subheader}>
                            {!this.state.success && (
                                <>
                                    <TextInput
                                        type={this.state.type}
                                        name='password'
                                        label={t('login:reset.password')}
                                        labelSub={t('login:reset.strong')}
                                        value={this.state.password}
                                        onChange={this.handleChange}
                                        error={this.state.masterErrorMsg}
                                        outerClassName='mar-b24'
                                        iconRight={
                                            <Icons
                                                icon='eye'
                                                className={
                                                    this.state.type === 'password'
                                                        ? 'icons-cross'
                                                        : 'icons-cross active'
                                                }
                                                color='var(--neutral-900)'
                                                onClick={() => {
                                                    this.setState({
                                                        type: this.state.type === 'password' ? 'text' : 'password'
                                                    })
                                                }}
                                            />
                                        }
                                    />
                                    <TextInput
                                        type='password'
                                        name='repeatPassword'
                                        label={t('login:reset.repeat')}
                                        value={this.state.repeatPassword}
                                        onChange={this.handleChange}
                                        outerClassName='mar-b32'
                                    />

                                    <Button
                                        className='button-primary button-fullwidth'
                                        iconRight={<Icons icon='arrowRight' />}
                                        onClick={this.send}
                                        disabled={this.state.loading}
                                    >
                                        {t('login:reset.button')}
                                    </Button>
                                    <div
                                        style={{ textAlign: 'center', color: 'var(--neutral-800)' }}
                                        className='mar-t16'
                                    >
                                        <Link to='/'>Back to log in</Link>
                                    </div>
                                </>
                            )}

                            {this.state.success && (
                                <Button
                                    className='button-primary button-fullwidth'
                                    iconRight={<Icons icon='arrowRight' />}
                                    to='/?redirect=/cp/home'
                                >
                                    {t('login:reset.login', { siteName: this.props.siteMaster.siteName })}
                                </Button>
                            )}
                        </LandingPageTemplate>
                    )
                    return (
                        <div className='login-holder'>
                            {(this.props.siteMaster.siteName === 'MPZMail' ||
                                this.props.siteMaster.siteName === 'Transpond') && (
                                <LeftPanel history={this.props.history} />
                            )}
                            <div className='login-right-panel'>
                                <div className='login-right-panel-login'>
                                    <Paper className='login-right-panel-login_loginBox'>
                                        <h3 className='mar-b15'>
                                            {i18n.t('login:reset.reset')} <span>{this.props.siteMaster.siteName}</span>{' '}
                                            {i18n.t('login:reminder.header2')}
                                        </h3>
                                        <div className='mar-b40'>{i18n.t('login:reset.new')}</div>

                                        <TextInput
                                            outerClassName='mar-b24'
                                            type='password'
                                            name='password'
                                            placeholder={i18n.t('login:reset.password')}
                                            onChange={this.handleChange}
                                            onKeyPress={this.handleChange}
                                            error={!this.state.strongEnough ? i18n.t('login:reset.strong') : ''}
                                            maxLength='255'
                                        />

                                        <TextInput
                                            type='password'
                                            name='repeatPassword'
                                            placeholder={i18n.t('login:reset.repeat')}
                                            onChange={this.handleChange}
                                            onKeyPress={this.handleChange}
                                            outerClassName='mar-b24'
                                            maxLength='255'
                                        />

                                        {this.state.masterErrorMsg}

                                        {!this.state.success && (
                                            <Button
                                                className='button-primary'
                                                text={i18n.t('login:reset.button')}
                                                onClick={this.send}
                                            />
                                        )}
                                        {this.state.success && (
                                            <Button
                                                className='button-primary'
                                                text={i18n.t('login:reset.login')}
                                                onClick={() => this.props.history.push('/')}
                                            />
                                        )}
                                    </Paper>
                                </div>
                            </div>
                        </div>
                    )
                }}
            </Translation>
        )
    }
}
